import { QueryClient } from '@tanstack/react-query';
import { ErroreRichiesta } from '@/api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (conteggio, errore) => {
        if (errore instanceof ErroreRichiesta && errore.status >= 400 && errore.status < 500) return false;
        return conteggio < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
